import { KebidananAlert } from "@/types/LembarObservasiAsuhanKebidanan";

export interface AlertInput {
  umur_ibu?: number | null;
  td_sistol?: number | null;
  td_diastol?: number | null;
  nadi?: number | null;
  suhu?: number | null;
  rr?: number | null;
  lila?: number | null;
  lab_hb?: number | null;
  djj?: number | null;
  anc_dilakukan?: boolean | null;
  anc_frekuensi?: number | null;
}

/**
 * Evaluasi alert klinis kebidanan (kehamilan risiko tinggi).
 * Non-mutating — mengembalikan array baru.
 */
export function evaluateKebidananAlerts(data: AlertInput): KebidananAlert[] {
  const alerts: KebidananAlert[] = [];

  if (data.umur_ibu != null && (data.umur_ibu < 15 || data.umur_ibu > 35)) {
    alerts.push({
      code: "umur_ekstrim",
      level: "warning",
      message: `Usia ibu ${data.umur_ibu} tahun — kategori kehamilan risiko tinggi.`
    });
  }
  if (
    data.td_sistol != null &&
    data.td_diastol != null &&
    (data.td_sistol >= 140 || data.td_diastol >= 90)
  ) {
    alerts.push({
      code: "hipertensi_gestasional",
      level: "critical",
      message: `TD ${data.td_sistol}/${data.td_diastol} mmHg — waspada pre-eklampsia.`
    });
  }
  if (data.lila != null && data.lila < 23.5) {
    alerts.push({
      code: "kek",
      level: "warning",
      message: `LILA ${data.lila} cm — KEK, risiko BBLR.`
    });
  }
  if (data.lab_hb != null && data.lab_hb < 11) {
    alerts.push({
      code: "anemia",
      level: "warning",
      message: `Hb ${data.lab_hb} g/dL — anemia kehamilan.`
    });
  }
  if (data.djj != null && (data.djj < 120 || data.djj > 160)) {
    alerts.push({
      code: "fetal_distress",
      level: "critical",
      message: `DJJ ${data.djj} x/menit — gawat janin.`
    });
  }
  if (
    data.anc_dilakukan &&
    data.anc_frekuensi != null &&
    data.anc_frekuensi < 6
  ) {
    alerts.push({
      code: "anc_tidak_adekuat",
      level: "info",
      message: `ANC baru ${data.anc_frekuensi}x — standar minimal 6x.`
    });
  }
  if (data.nadi != null && data.nadi > 100) {
    alerts.push({
      code: "takikardia",
      level: "warning",
      message: `Nadi ${data.nadi} x/menit — takikardia.`
    });
  }
  if (data.nadi != null && data.nadi < 60) {
    alerts.push({
      code: "bradikardia",
      level: "warning",
      message: `Nadi ${data.nadi} x/menit — bradikardia.`
    });
  }
  if (data.suhu != null && data.suhu > 37.5) {
    alerts.push({
      code: "demam",
      level: "warning",
      message: `Suhu ${data.suhu} °C — demam.`
    });
  }
  if (data.suhu != null && data.suhu < 36) {
    alerts.push({
      code: "hipotermia",
      level: "warning",
      message: `Suhu ${data.suhu} °C — hipotermia.`
    });
  }
  if (data.rr != null && (data.rr > 24 || data.rr < 12)) {
    alerts.push({
      code: "rr_abnormal",
      level: "warning",
      message: `RR ${data.rr} x/menit — abnormal.`
    });
  }
  return alerts;
}
